import CommentCard from './CommentCard';

export default CommentCard;
